import React from 'react';

//countup
import CountUp from 'react-countup';

//intersection observer hook
import { useInView } from 'react-intersection-observer';

//motion
import { motion } from 'framer-motion';

//variant
import { fadeIn } from '../variants';

//link
import { Link } from 'react-scroll';

const About = () => {

  const [ref, inView] = useInView({
    threshold: 0.5,
  });

  return (
    <section id='about' className='section' ref={ref}>
      <div className='container mx-auto'>
        <div className='flex flex-col gap-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen'>

          {/* img */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 bg-about bg-contain bg-no-repeat h-[640px] mix-blend-luminosity bg-top'></motion.div>

          {/* text */}
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'>
            <div>
              <h2 className='h2 text-accent'>About Me.</h2>
              <h4 className='h4 font-bold mb-2'>
                Elevating Ideas with Technology
              </h4>
              <h3 className='h3 mb-2'>
                Greetings, I'm Mire Patel
              </h3>
              <p className='mb-6 text-justify'>
                Recent graduate in Computer Science and Engineering with a CGPA of 9.38 from Pandit Deendayal Energy University in Gandhinagar, Gujarat. Skilled in HTML, CSS, JavaScript, Python, and C++. Passionate about Frontend Development, enthusiastic about creative web design, and merging technology and design to craft visually appealing interfaces.
              </p>

              {/* Stats */}
              <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
                <div>
                  <div className='text-[40px] font-primary text-gradient mb-2 leading-normal'>
                    {inView ? <CountUp start={0} end={2.5} decimals={1} duration={3} /> : null}
                  </div>
                  <div className='font-primary text-sm tracking-[2px]'>
                    Years of <br />Experience in <br />Creative Field
                  </div>
                </div>

                <div>
                  <div className='text-[40px] font-primary text-gradient mb-2 leading-normal'>
                    {inView ? <CountUp start={0} end={12} duration={3} /> : null}

                  </div>
                  <div className='font-primary text-sm tracking-[2px]'>
                    Projects <br />Completed
                  </div>
                </div>

                <div>
                  <div className='text-[40px] font-primary text-gradient mb-2 leading-normal'>
                    {inView ? <CountUp start={0} end={9.38} decimals={2} duration={3} /> : null}
                  </div>
                  <div className='font-primary text-sm tracking-[2px]'>
                    CGPA
                  </div>
                </div>
              </div>
            </div>

            <p className='mb-6 text-justify'>
              Seeking opportunities to contribute and grow. Let's connect and explore possibilities!
            </p>

            <div className='flex gap-x-8 items-center'>
              {/* <button className='btn btn-lg'>Contact me</button> */}
              {/* button */}
              <Link className='btn btn-lg cursor-pointer flex items-center justify-center' to='contact' smooth={true} spy={true}>
                Contact me
              </Link>
              {/* <a href='https://drive.google.com/uc?export=download&id=1GqWsHRI4e5n7jdbXbM-5fmaNDlbRYW2G' className='btn-link' download>
                Download Resume
              </a> */}
              <Link className='btn btn-link cursor-pointer flex items-center justify-center' to='work' smooth={true} spy={true}>
                See my work
              </Link>
              {/* <a href='/' className='btn-link'>My Portfolio</a> */}
            </div>
          </motion.div>
        </div>
      </div>
    </section >
  );
};

export default About;
